var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pain-point"},[_c('div',{staticClass:"point-content"},[_c('h2',{staticClass:"content-title"},[_vm._v("解决痛点")]),_c('div',{staticClass:"content-box"},_vm._l((_vm.painPointContent),function(item,index){return _c('div',{key:index,staticClass:"box-item"},[_c('div',{staticClass:"item-icon",style:({
            'background-image': `url(${
              _vm.iconList ? _vm.iconList[index] : _vm.icon[index]
            })`,
          })}),_c('p',{staticClass:"item-content"},[_vm._v(" "+_vm._s(item)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }